import axios from 'axios';

const API_BASE = '/api/auth';

export interface AuthResponse {
  success: boolean;
  data: {
    token: string;
    user: AthleteUserData | CompanyUserData;
  };
}

export interface AthleteUserData {
  uuid: string;
  email: string;
  name: string;
  prefecture: string | null;
  userType: 'athlete';
  emailVerified: boolean;
  hasProfile?: boolean;
  privacyState?: string | null;
}

export interface CompanyUserData {
  uuid: string;
  email: string;
  companyName: string;
  contactPerson: string;
  phone?: string;
  website?: string;
  userType: 'company';
  planState: string;
  emailVerified: boolean;
}

export type UserData = AthleteUserData | CompanyUserData;

export const authService = {
  async athleteRegister(data: {
    email: string;
    password: string;
    name: string;
    prefecture: string;
  }): Promise<AuthResponse> {
    const res = await axios.post(`${API_BASE}/athlete-register.php`, data);
    return res.data;
  },

  async athleteLogin(email: string, password: string): Promise<AuthResponse> {
    const res = await axios.post(`${API_BASE}/athlete-login.php`, { email, password });
    return res.data;
  },

  async companyRegister(data: {
    email: string;
    password: string;
    companyName: string;
    contactPerson: string;
    phone?: string;
    website?: string;
  }): Promise<AuthResponse> {
    const res = await axios.post(`${API_BASE}/company-register.php`, data);
    return res.data;
  },

  async companyLogin(email: string, password: string): Promise<AuthResponse> {
    const res = await axios.post(`${API_BASE}/company-login.php`, { email, password });
    return res.data;
  },

  async verifyEmail(token: string): Promise<{ success: boolean; message: string }> {
    const res = await axios.post(`${API_BASE}/verify-email.php`, { token });
    return res.data;
  },

  async forgotPassword(email: string, userType: 'athlete' | 'company'): Promise<{ success: boolean; message: string }> {
    const res = await axios.post(`${API_BASE}/forgot-password.php`, { email, userType });
    return res.data;
  },

  async resetPassword(token: string, password: string): Promise<{ success: boolean; message: string }> {
    const res = await axios.post(`${API_BASE}/reset-password.php`, { token, password });
    return res.data;
  },

  async getMe(): Promise<{ success: boolean; data: UserData }> {
    const res = await axios.get(`${API_BASE}/me.php`);
    return res.data;
  },

  async logout(): Promise<void> {
    await axios.post(`${API_BASE}/logout.php`);
  },
};
